module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-8-small-11d090565b2c3dfd379044f0dde09da3.jpg";